import React from 'react';
import * as PropTypes from 'prop-types';

import Link from 'ati-ui-react/components/Link';

import styles from './styles.modules.scss';

export const DirectionsLink = ({idFrom, idTo, nameFrom, nameTo, onClick}) => {
    const handleLinkClick = () => onClick(idFrom, 2, idTo, 2);

    return (
        <Link
            small
            className={styles['link']}
            type="pseudo"
            onClick={handleLinkClick}
        >
            {`${nameFrom} — ${nameTo}`}
        </Link>
    );
};

export default DirectionsLink;

DirectionsLink.propTypes = {
    idFrom: PropTypes.number,
    idTo: PropTypes.number,
    nameFrom: PropTypes.string,
    nameTo: PropTypes.string,
    onClick: PropTypes.func
};
